import {userInitialBackgroundColors} from "../constants/color.constants";

/**
 * Check if a string is null, undefined, or consists of only whitespace.
 * @param {string} str - The string to check.
 * @returns {boolean} - Returns true if the string is null, undefined, or whitespace.
 */
export function isNullOrWhiteSpace(str) {
    return str == null || /^\s*$/.test(str);
}

/**
 * Lower Case the first letter in the string.
 * @param {string} str - The string to check.
 * @returns {string} - Returns the string.
 */
export function lowerCaseFirstLetter(str) {
    if (typeof str === "string") {
        return str.charAt(0).toLowerCase() + str.slice(1);
    }
    return str;
}

/**
 * Upper Case the first letter in the string.
 * @param {string} str - The string to check.
 * @returns {string} - Returns the string.
 */
export function upperCaseFirstLetter(str) {
    if (typeof str === "string") {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    return str;
}

/**
 * Remove Alpha Characters from data.
 * @param {string} str - The string to check.
 * @returns {string} - Returns the string.
 */
export function removeAlphabetsFromString(str) {
    if (typeof str === "string") {
        return str.replace(/[a-zA-Z$%€£¥₹]/g, "");
    }
    return str;
}

/**
 * Convert String to Boolean.
 * @param {string} str - The string to check.
 * @returns {boolean} - Returns the string.
 */
export function convertToBoolean(str) {
    if (typeof str !== "string") {
        return false
    }
    if (str.length === 0) return false;

    if (str === 'true' || str === 'True') {
        return true;
    }

    if (str === 'false' || str === 'False') {
        return false;
    }

    return false;
}

/**
 * Convert line break code to Line Breaks.
 * @param {string | null } str - The string to check.
 * @returns {string} - Returns the string.
 */
export function convertToNewLineBreaks(str) {
    if (str === null || typeof str === "undefined" || typeof str !== "string") {
        return str;
    }

    return str.replace(/\r\n/g, "\n"); // Renders with line breaks
}

/**
 * Convert Name or Email to first letters.
 * @param {string | null } str - The string to check.
 * @returns {string} - Returns the string.
 */
export function userInitial(str) {
    if (str === null || typeof str === "undefined" || typeof str !== "string") {
        return str;
    }

    let first = '';
    let last = '';

    // Manage Emails with a dot as Break.
    if (str.includes('@')) {
        const localPart = str.split('@')[0];
        const parts = localPart.split('.');

        if (parts.length > 1) {
            first = parts[0] || '';
            last = parts[1] || '';
        }
        /* V. 3 and 3 */
        else if (parts.length === 1 && parts[0].length >= 6 ) {
            first = parts[0][0];
            last = parts[0][3];
        }
        else {
            first = parts[0];
        }
    }
    //Manage Lastname, Firstname
    else if (str.includes(',')) {
        // Comma case: "LastName, FirstName"
        const parts = str.split(',');
        last = parts[0].trim();
        first = parts[1]?.trim() || '';
    }
    //Manage Firstname Lastname
    else {
        // Normal full name: "FirstName LastName"
        const parts = str.trim().split(/\s+/);
        first = parts[0] || '';
        last = parts[1] || '';
    }

    const firstInitial = first.charAt(0).toUpperCase();
    const lastInitial = last.charAt(0).toUpperCase();

    return firstInitial + lastInitial;
}

/**
 * Get A Background Color based on Initials
 * @param {string | null } str - The string to check.
 * @returns {string} - Returns the string.
 */
export function userInitialBackgroundColor(str) {

    if (!str) return userInitialBackgroundColors[0];

    // Simple hash: sum char codes modulo palette length
    const charCodesSum = str
        .split('')
        .reduce((sum, char) => sum + char.charCodeAt(0), 0);

    return userInitialBackgroundColors[charCodesSum % userInitialBackgroundColors.length];
}

/**
 * Pluralise String.
 * @param {Array | null } items - The Array to check.
 * @param {string | null } singular - The string to pluralise.
 * @param {string | null } plural - The pluralisation replacement. (person -> people)
 * @returns {string} - Returns the string.
 */
export function pluralize(items, singular, plural = null) {
    return `${items?.length ?? 0} ${(items?.length ?? 0) === 1 ? singular : (plural || singular + 's')}`;
}